<template>
  <div class="switch" :class="{ 'no-action': disabled }" :style="marginTop">
    <input
        :class="{ 'no-action': disabled, 'cmn-toggle cmn-toggle-round-flat' : isInList === false, 'list-toggle list-toggle-round-flat': isInList}"
        type="checkbox"
        :disabled="disabled"
        :checked="value"
        @change="changeFn"
        :id="identification"
        :formControlName="identification"
    >
    <label :class="{ 'no-action': disabled }" style="margin-bottom: 0 !important;" :for="identification"></label>
  </div>
</template>

<script>
import { mainEventBus } from "../../../main";

export default {
  name: "SwitchComponent",
  methods: {
    changeFn(e) {
      if (!this.autoSave) {
        this.$emit('input', e.target.checked);
        return;
      }
      this.$emit('input', e.target.checked);
      if (this.item) mainEventBus.$emit('switchedActivity', this.item);
      this.$emit('switchedActivateCode');
    }
  },
  props: ['value', 'identification', 'mt', 'item', 'isInList', 'autoSave', 'disabled'],
  computed: {
    marginTop() {
      return this.mt ? `margin-top: ${this.mt};` : this.isInList ? `margin-top: 5px;` : `margin-top: 0;`;
    }
  }
}
</script>

<style scoped>
.no-action { cursor: not-allowed !important; }
.cmn-toggle,
.list-toggle {
  position: absolute;
  margin-left: -9999px;
  visibility: hidden;
}

.cmn-toggle + label,
.list-toggle + label {
  display: block;
  position: relative;
  cursor: pointer;
  outline: none;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
}

input.cmn-toggle-round-flat + label {
  padding: 2px;
  width: 55px;
  height: 22px;
  background-color: #dddddd;
  -webkit-border-radius: 60px;
  -moz-border-radius: 60px;
  -ms-border-radius: 60px;
  -o-border-radius: 60px;
  border-radius: 60px;
  -webkit-transition: background 0.4s;
  -moz-transition: background 0.4s;
  -o-transition: background 0.4s;
  transition: background 0.4s;
}

input.cmn-toggle-round-flat + label:before, input.cmn-toggle-round-flat + label:after,
input.list-toggle-round-flat + label:before, input.list-toggle-round-flat + label:after {
  display: block;
  position: absolute;
  content: "";
}

input.cmn-toggle-round-flat + label:before,
input.list-toggle-round-flat + label:before {
  top: 2px;
  left: 2px;
  bottom: 2px;
  right: 2px;
  background-color: #fff;
  -webkit-border-radius: 60px;
  -moz-border-radius: 60px;
  -ms-border-radius: 60px;
  -o-border-radius: 60px;
  border-radius: 60px;
  -webkit-transition: background 0.4s;
  -moz-transition: background 0.4s;
  -o-transition: background 0.4s;
  transition: background 0.4s;
}

input.cmn-toggle-round-flat + label:after {
  top: 4px;
  left: 4px;
  bottom: 4px;
  width: 15px;
  background-color: #dddddd;
  -webkit-border-radius: 52px;
  -moz-border-radius: 52px;
  -ms-border-radius: 52px;
  -o-border-radius: 52px;
  border-radius: 52px;
  -webkit-transition: margin 0.4s, background 0.4s;
  -moz-transition: margin 0.4s, background 0.4s;
  -o-transition: margin 0.4s, background 0.4s;
  transition: margin 0.4s, background 0.4s;
}

input.cmn-toggle-round-flat:checked + label  {
  background: linear-gradient(0deg, #bbbf8f, #758a4e 80%, #c5e486 20%, #65714a);
}

input.cmn-toggle-round-flat:checked + label:after {
  margin-left: 32px;
  background: linear-gradient(0deg, #bbbf8f, #758a4e 80%, #c5e486 20%, #65714a);
}

/* LIST TOGGLER DOWN HERE */

input.list-toggle-round-flat + label {
  padding: 2px;
  width: 45px;
  height: 17px;
  background-color: #dddddd;
  -webkit-border-radius: 60px;
  -moz-border-radius: 60px;
  -ms-border-radius: 60px;
  -o-border-radius: 60px;
  border-radius: 60px;
  -webkit-transition: background 0.4s;
  -moz-transition: background 0.4s;
  -o-transition: background 0.4s;
  transition: background 0.4s;
}

input.list-toggle-round-flat + label:after {
  top: 4px;
  left: 4px;
  bottom: 4px;
  width: 10px;
  background-color: #dddddd;
  -webkit-border-radius: 52px;
  -moz-border-radius: 52px;
  -ms-border-radius: 52px;
  -o-border-radius: 52px;
  border-radius: 52px;
  -webkit-transition: margin 0.4s, background 0.4s;
  -moz-transition: margin 0.4s, background 0.4s;
  -o-transition: margin 0.4s, background 0.4s;
  transition: margin 0.4s, background 0.4s;
}

input.list-toggle-round-flat:checked + label  {
  background: linear-gradient(0deg, #bbbf8f, #758a4e 80%, #c5e486 20%, #65714a);
}

input.list-toggle-round-flat:checked + label:after {
  margin-left: 27px;
  background: linear-gradient(0deg, #bbbf8f, #758a4e 80%, #c5e486 20%, #65714a);
}
</style>


// WEBPACK FOOTER //
// Switch.vue?5650f98a